'use strict';

/* jshint -W098 */
angular.module('mean.databases').controller('DatabasesTasksController', ['$scope', 'Global', 'MeanUser', 'userService', 'builderService', 'ngDialog', 'toaster', '$filter', 'ProjectTasks', 'aceUtils',
  function($scope, Global, MeanUser, userService, builderService, ngDialog, toaster, $filter, ProjectTasks, aceUtils) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.sortType = ['project_id.builder.name', 'project_id.name'];
    $scope.sortReverse = false;

    $scope.user = MeanUser.user;

    $scope.$on('tasksLoadEvent', function (event, data) {
        $scope.tasks = [];
        ProjectTasks.query({ 'trade': $scope.user.trade[0],
            'tasked_trade': userService.getMainUsername($scope.user.username),
            'status': data.searchProp.status,
            'project_id': data.searchProp.project_id,
            'phase': data.searchProp.phase,
            'lot': data.searchProp.lot,
            'task': data.searchProp.task,
            'scheduledEnabled': data.scheduledEnabled,
            'scheduledStart': data.scheduledStart,
            'scheduledEnd': data.scheduledEnd,
            'completedEnabled': data.completedEnabled,
            'completedStart': data.completedStart,
            'completedEnd': data.completedEnd,
            'populateMin': true }, function(tasksdb) {
            $scope.tasks = tasksdb;
        });
    });
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/databases-tasks.js